import ProductCard from "./ProductCard";

export default function ProductList({ products, isLoading }) {

 if (products.length === 0) {
    return (
      <div className="text-center p-10 bg-gray-50 dark:bg-gray-800/50 rounded-lg">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-200 mb-2">No staking products found</h3>
        <p className="text-gray-500 dark:text-gray-400">
          Create your first staking product to get started.
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
      {products.map(product => (
        <ProductCard key={product.id} product={product} />
      ))}
    </div>
  );
}